import MethodChip from './MethodChip';
import { MethodChipProps, MethodChipValueProps } from './types';

export type { MethodChipProps, MethodChipValueProps };
export default MethodChip;
